import { AuditLogEntry, type AuditActorType } from '@bartizo/shared';
import { apiPageRequest, type Page } from './client.js';

/** The audit log (knowledge doc section 15: `GET /audit-log`; admins only). */

export interface AuditLogFilters {
  actor_type?: AuditActorType;
  actor_id?: string;
  /** A prefix: `server.` is everything done to servers. */
  action?: string;
  target?: string;
  from?: string;
  to?: string;
  limit?: number;
  cursor?: string;
}

const toQueryString = (filters: AuditLogFilters): string => {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(filters)) {
    if (value === undefined || value === '') continue;
    params.set(key, String(value));
  }
  const query = params.toString();
  return query.length > 0 ? `?${query}` : '';
};

export const listAuditLog = (filters: AuditLogFilters = {}): Promise<Page<AuditLogEntry>> =>
  apiPageRequest(`/audit-log${toQueryString(filters)}`, { schema: AuditLogEntry });
